module.exports = "@import url(\"//hello.myfonts.net/count/3a0513\");\n@font-face {\n  font-family: \"NotoSans\";\n  src: url(\"/Content/fonts/Noto_Sans/NotoSans-VariableFont_wdth,wght.ttf\") format(\"truetype\"); }\n.view-visualizer {\n  height: calc(100% - 77px);\n  background: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/visualizer/visualizer/visualizer.component.scss
// module id = ./src/app/components/visualizer/visualizer/visualizer.component.scss
// module chunks = main